export default "__VITE_ASSET__BNMmC9Mb__"